/**
 * Selectores PUROS de la comunidad (F3-C) — testeables sin BD.
 *   • `countUnread`      — contador del bell (read_at nulo).
 *   • `groupThreadPosts` — anidamiento de 1 nivel (top-level + respuestas por
 *     padre) para la vista de hilo.
 */

export interface UnreadLike {
  read_at?: string | null;
}

/** Nº de notificaciones NO leídas (read_at null/undefined). */
export function countUnread(notifications: readonly UnreadLike[]): number {
  return notifications.reduce((n, x) => (x.read_at ? n : n + 1), 0);
}

export interface PostLike {
  id: string;
  reply_to_id?: string | null;
}

export interface GroupedPosts<T extends PostLike> {
  /** Posts de nivel superior (sin reply_to). */
  topLevel: T[];
  /** Respuestas agrupadas por id del post padre. */
  repliesByParent: Map<string, T[]>;
}

/**
 * Agrupa los posts de un hilo en 1 nivel: los que no tienen `reply_to_id` son
 * top-level; el resto cuelgan de su padre. Una respuesta cuyo padre NO está en
 * la lista (p. ej. oculto/borrado) se promueve a top-level para no perderse.
 */
export function groupThreadPosts<T extends PostLike>(posts: readonly T[]): GroupedPosts<T> {
  const ids = new Set(posts.map((p) => p.id));
  const topLevel: T[] = [];
  const repliesByParent = new Map<string, T[]>();
  for (const p of posts) {
    const parent = p.reply_to_id;
    if (parent && ids.has(parent)) {
      const arr = repliesByParent.get(parent) ?? [];
      arr.push(p);
      repliesByParent.set(parent, arr);
    } else {
      topLevel.push(p);
    }
  }
  return { topLevel, repliesByParent };
}
